import {SingleChoiceQuestion} from './SingleChoiceQuestion';
import {MultiChoiceQuestion} from './MultiChoiceQuestion';
import {DropdownQuestion} from './DropdownQuestion';

export class ChoiceQuestionThemeV5 {
    constructor(questionNode, onChange, type) {
        this.domNode = questionNode;
        this.onChange = onChange;
        this.questionObject = null;

        switch (type) {
            case 'SINGLECHOICE':
                this.questionObject = new SingleChoiceQuestion(questionNode, onChange);
                break;
            case 'MULTICHOICE':
            case 'MULTICHOICE2':
                this.questionObject = new MultiChoiceQuestion(questionNode, onChange);
                break;
            case 'SINGLECHOICE2':
                this.questionObject = new DropdownQuestion(questionNode, onChange);
                break;
        }
    }
}